<template>
    <div>
        <portal to="toolbar-title">Νέο Αίτημα</portal>
        <portal to="toolbar-actions">
        </portal>
        <new-issue/>
    </div>
</template>

<script>
    import NewIssue from "../components/NewIssue";
    export default {
        name: "AddIssue",
        components: {NewIssue}
    }
</script>

<style scoped>

</style>
